module.exports = __webpack_public_path__ + "img/drugs.7ff36ed.jpg";